const OtherIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 45 34"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.78231 34L32.1496 34C33.4545 34 34.4757 33.3389 35.1565 32.3378L44.688 18.0389C45.104 17.3967 45.104 16.5844 44.688 15.9422L35.1565 1.66222C34.4757 0.679999 33.3221 -1.02091e-06 32.0172 -1.13499e-06L3.78231 -3.60337e-06C1.70204 -3.78523e-06 2.82376e-06 1.7 2.64211e-06 3.77777L3.30264e-07 30.2222C1.48619e-07 32.3 1.70204 34 3.78231 34ZM28.3673 14.1667C29.937 14.1667 31.204 15.4322 31.204 17C31.204 18.5678 29.937 19.8333 28.3673 19.8333C26.7976 19.8333 25.5306 18.5678 25.5306 17C25.5306 15.4322 26.7976 14.1667 28.3673 14.1667ZM18.9115 14.1667C20.4812 14.1667 21.7483 15.4322 21.7483 17C21.7483 18.5678 20.4812 19.8333 18.9115 19.8333C17.3419 19.8333 16.0748 18.5678 16.0748 17C16.0748 15.4322 17.3419 14.1667 18.9115 14.1667ZM9.45577 14.1667C11.0254 14.1667 12.2925 15.4322 12.2925 17C12.2925 18.5678 11.0254 19.8333 9.45577 19.8333C7.88611 19.8333 6.61904 18.5678 6.61904 17C6.61904 15.4322 7.88611 14.1667 9.45577 14.1667Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default OtherIcon
